import React from "react"
import "./week-card.scss"
export default props =>
    <div className="week-panel" data-sal="slide-up"
        data-sal-duration="700"
        data-sal-easing="ease">
        <div className="left-line" style={{backgroundColor:`${props.color}`}} />
        <div className={"week-text"}>
            <div className={`week-title`}>{props.title}</div>
            <div className="week-des">{props.children}</div>
        </div>
    </div>